export const IGNORE_ALL_STATUSES = '*';
